import React, { useCallback, useEffect, useMemo, useState } from "react";

import { useTreeState } from "../../../hooks/useTreeState";
import { connect, useSelector } from "react-redux";
import { useSharedListStyles } from "../../../shared/useSharedListStyles";
import ObjecttypeService from "../../../services/ObjecttypeService";
import MaterialTable, { MTableToolbar } from "@material-table/core";
import { header } from'../../../shared/headerStyle';
import ComponentTypeAutoComplete from "../../../shared/ComponentTypeAutoComplete";
import DataComponentService from "../../../services/DataComponentService";
import {
    Button,
    List,
    ListItem,
    Paper,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import ObjecttypeSelectlist from "../../../shared/ObjecttypeSelectlist";
import EnumeratorDialog from "./EnumeratorDialog";
import { buildFieldColumns } from "./buildFieldColumns";

const HEADER_HEIGHT = 88;
const TOOLBAR_HEIGHT = 74;
const PAGINATION_HEIGHT = 52;


function ObjectFields({realm}) {
    const token = useSelector((state) => state.keycloakToken);
    const [optionsRO, setOptionsRO] = useState([]);
    const [optionsAO, setOptionsAO] = useState([]);
    const [selectedRO, setSelectedRO] = useState('');
    const [selectedAO, setSelectedAO] = useState('');
    const [typeGuid, setTypeGuid] = useState('');
    const classes = useSharedListStyles();

    const tree = useTreeState();
    const treeItemsState = tree.items;
    const [value, setValue] = useState(null);

    const [arrTitle, setArrTitle] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const bla = await ObjecttypeService.getRealestateobjecttypes(token, realm);
            const myOptions = [];
            const myTitles = [];
            if (bla.data && bla.data instanceof Array) {
                // myOptions[0] = {value: '', text: ' - Bitte wählen -'}
                bla.data?.forEach((val) => {
                    const item = {value: val.guid, text: val.label}
                    myOptions.push(item);
                    myTitles[val.guid] = val.label;
                })
            }
            setOptionsRO(myOptions);
            setSelectedRO('');
            const bla2 = await ObjecttypeService.getAdministrativeobjecttypes(token, realm);
            const myOptions2 = [];
            if (bla2.data && bla2.data instanceof Array) {
                // myOptions2[0] = {value: '', text: ' - Bitte wählen -'}
                bla2.data?.forEach((val) => {
                    const item = {value: val.guid, text: val.label}
                    myOptions2.push(item);
                    myTitles[val.guid] = val.label;
                })
            }
            setOptionsAO(myOptions2);
            setSelectedAO('');
            setArrTitle(myTitles);
            setTypeGuid('');
        }
        fetchData();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const [title, setTitle] = useState('');
    const [fieldType, setFieldType] = useState('realestateobjectType');
    const [columnData, setColumnData] = useState([]);
    const [dialogRow, setDialogRow] = useState(null);

    const reloadFields = useCallback(async () => {
        if (fieldType === 'administrativeobjectType') {
            const res = await ObjecttypeService.getAdministrativeobjectFields(selectedAO, token, realm);
            setColumnData(res?.data);
        } else if (fieldType === 'realestateobjectType') {
            const res = await ObjecttypeService.getRealestateobjectFields(selectedRO, token, realm);
            setColumnData(res?.data);
        } else if (fieldType === 'componentType') {
            const res = await DataComponentService.getComponentTypeAttributeFieldsByGuid(token, realm, value.globalId);
            setColumnData(res?.data);
        }
    }, [fieldType, selectedAO, selectedRO, value, token, realm]);

    const handleChange = async (event) => {
        const myRoValue = event.target.value;
        const listFields = await ObjecttypeService.getRealestateobjectFields(myRoValue, token, realm);
        const sortedFields = listFields?.data?.sort((a, b) => a.label.localeCompare(b.label));
        setColumnData(sortedFields);
        setSelectedRO(myRoValue);
        setTypeGuid(myRoValue);
        setSelectedAO('');
        setTitle(arrTitle[myRoValue]);
        setFieldType('realestateobjectType');
        setValue(null);
    };

    const handleChangeAO = async (event) => {
        const myAoValue = event.target.value;
        const listFields = await ObjecttypeService.getAdministrativeobjectFields(myAoValue, token, realm);
        const sortedFields = listFields?.data?.sort((a, b) => a.label.localeCompare(b.label));
        setColumnData(sortedFields);
        setSelectedAO(myAoValue);
        setTypeGuid(myAoValue);
        setSelectedRO('');
        setFieldType('administrativeobjectType');
        setTitle(arrTitle[myAoValue]);
        setValue(null);
    };

    const treeFlatList = useMemo(() => {
        const list = [];
        function convert(item) {
            list.push({
                name: item.name,
                id: item.objecttype_id,
                code: item.code,
                title: item.code + ' - ' + item.name,
                cafmId: item.cafm_id,
                globalId: item.global_id,
                key: item.global_id,
            });
            item.children_objecttypes?.forEach(child => convert(child));
        }
        treeItemsState.forEach(item => convert(item));
        return list;
    }, [treeItemsState]);

    const changedComponenttypeValue = async (val) => {
        if (val) {
            const listFields = await DataComponentService.getComponentTypeAttributeFieldsByGuid(token, realm, val.globalId);
            const sortedFields = listFields?.data?.sort((a, b) => a.name.localeCompare(b.name));
            setColumnData(sortedFields);
            setSelectedAO('');
            setSelectedRO('');
            setTypeGuid('');
            setFieldType('componentType');
            setTitle(val.code + ' - ' + val.name + ' (' + val.globalId + ')');
            setValue(val);
        }
    };

    const tableHeight = `calc(100vh - ${HEADER_HEIGHT + TOOLBAR_HEIGHT + 50 + PAGINATION_HEIGHT}px)`; // filter-bar + toolbar + col-header + pagination + padding

    // ↓ Hier das Aussehen des "Feld hinzufügen"-Buttons anpassen
    const FieldsToolbar = useCallback((props) => {
        const { onAddClicked, actions = [], ...rest } = props;
        const rowActions = actions.filter(a => !a.isFreeAction);
        return (
            <>
                <MTableToolbar {...rest} actions={rowActions} />
                {onAddClicked && (
                    <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        startIcon={<AddIcon />}
                        onClick={onAddClicked}
                        style={{ position: 'absolute', right: '16px', top: '14px' }}
                    >
                        Feld hinzufügen
                    </Button>
                )}
            </>
        );
    }, []);

    const columns = useMemo(
        () => buildFieldColumns(fieldType, setDialogRow),
        [fieldType]
    );

    const addRow = useMemo(() => {
        if (fieldType !== 'realestateobjectType' && fieldType !== 'administrativeobjectType') return undefined;
        return async (newData) => {
            try {
                if (fieldType === 'administrativeobjectType') {
                    await ObjecttypeService.saveAdministrativeobjectTypeAttribute(selectedAO, newData, token, realm);
                } else {
                    await ObjecttypeService.saveRealestateobjectTypeAttribute(selectedRO, newData, token, realm);
                }
                await reloadFields();
            } catch (err) {
                console.error("Fehler beim Hinzufügen:", err);
            }
        };
    }, [fieldType, selectedAO, selectedRO, token, realm, reloadFields]);

    return (
        <div>
            <div className={classes.katalogView}>
                <List>
                    <ListItem sx={{ gap: '12px' }}>
                        <ObjecttypeSelectlist
                            options={optionsRO}
                            selected={selectedRO}
                            handleChange={handleChange}
                            label="Immobilienobjekt"
                            style={{ minWidth: 260 }}
                            />
                        <ObjecttypeSelectlist
                            options={optionsAO}
                            selected={selectedAO}
                            handleChange={handleChangeAO}
                            label="Verwaltungsobjekt"
                            style={{ minWidth: 260 }}
                            />
                        {/*<Autocomplete
                            options={optionsRO.filter(o => o.value !== '')}
                            getOptionLabel={option => option.text}
                            isOptionEqualToValue={(opt, val) => opt.value === val.value}
                            value={selectedRO ? (optionsRO.find(o => o.value === selectedRO) ?? null) : null}
                            onChange={(_, newVal) => handleChange({ target: { value: newVal?.value ?? '' } })}
                            sx={{ minWidth: 260 }}
                            renderInput={(params) => <TextField {...params} label="Immobilienobjekt wählen" />}
                        />*/}
                        {/*<Autocomplete
                            options={optionsAO.filter(o => o.value !== '')}
                            getOptionLabel={option => option.text}
                            isOptionEqualToValue={(opt, val) => opt.value === val.value}
                            value={selectedAO ? (optionsAO.find(o => o.value === selectedAO) ?? null) : null}
                            onChange={(_, newVal) => handleChangeAO({ target: { value: newVal?.value ?? '' } })}
                            sx={{ minWidth: 260 }}
                            renderInput={(params) => <TextField {...params} label="Verwaltungsobjekt wählen" />}
                        />*/}
                        <ComponentTypeAutoComplete
                            flatList={treeFlatList}
                            setValue={changedComponenttypeValue}
                            value={value}
                            label="Bauteiltypen wählen oder Text eingeben"
                        />
                    </ListItem>
                </List>
                <div className={classes.btListe} style={{ padding: '12px', boxSizing: 'border-box' }}>
                    <MaterialTable
                        title={title}
                        columns={columns}
                        components={{
                            Container: props => <Paper {...props} style={{ ...props.style, position: 'relative' }} />,
                            Toolbar: FieldsToolbar,
                        }}
                        options={{
                            headerStyle: header,
                            pageSize: 10,
                            pageSizeOptions: [10, 20, 50, 100],
                            search: false,
                            actionsColumnIndex: -1,
                            exportButton: true,
                            exportAllData: true,
                            maxBodyHeight: tableHeight,
                            minBodyHeight: tableHeight,
                        }}
                        data={columnData}
                        localization={{
                            pagination: {
                                labelDisplayedRows: '{from}-{to} von {count}',
                                labelRowsSelect: 'Zeilen',
                                labelRowsPerPage: 'Zeilen pro Seite'
                            },
                            toolbar: {
                                nRowsSelected: '{0} Zeile(n) ausgewählt',
                                searchTooltip: 'Suchen',
                                searchPlaceholder: 'Suchbegriff eingeben'
                            },
                            header: {
                                actions: ''
                            },
                            body: {
                                emptyDataSourceMessage: 'Keine Einträge gefunden',
                                filterRow: {
                                    filterTooltip: 'Filter'
                                },
                                editRow: {
                                    deleteText: 'Soll der Datensatz wirklich gelöscht werden?',
                                    saveTooltip: 'Speichern',
                                    cancelTooltip: 'Abbrechen'
                                }
                            }
                        }}
                        editable={{
                            isDeletable: rowData => !rowData.catalog_property_guid,
                            onRowAdd: addRow,
                            onRowUpdate: async (newData) => {
                                try {
                                    if (fieldType === 'administrativeobjectType') {
                                        await ObjecttypeService.saveAdministrativeobjectTypeAttribute(selectedAO, newData, token, realm);
                                    } else if (fieldType === 'realestateobjectType') {
                                        await ObjecttypeService.saveRealestateobjectTypeAttribute(selectedRO, newData, token, realm);
                                    } else if (fieldType === 'componentType') {
                                        await ObjecttypeService.saveComponentTypeAttribute(value.globalId, newData, token, realm);
                                    }
                                    await reloadFields();
                                } catch (err) {
                                    console.error("Fehler beim Aktualisieren:", err);
                                }
                            },
                            onRowDelete: async (oldData) => {
                                try {
                                    if (fieldType === 'administrativeobjectType') {
                                        await ObjecttypeService.deleteAdministrativeobjectTypeAttribute(selectedAO, oldData.guid, token, realm);
                                    } else if (fieldType === 'realestateobjectType') {
                                        await ObjecttypeService.deleteRealestateobjectTypeAttribute(selectedRO, oldData.guid, token, realm);
                                    }
                                    // componentType delete not yet implemented
                                    await reloadFields();
                                } catch (err) {
                                    console.error("Fehler beim Löschen:", err);
                                }
                            },
                        }}
                    />
                </div>
                {dialogRow && (
                    <EnumeratorDialog
                        realm={realm}
                        token={token}
                        open={!!dialogRow}
                        row={dialogRow}
                        typeGuid={typeGuid}
                        setColumnData={setColumnData}
                        fieldType={fieldType}
                        onClose={() => setDialogRow(null)}
                    />
                )}
            </div>
        </div>
    );
}

function mapState({theRealm}) {
    return {
        realm: theRealm
    }
}

export default connect(
    mapState,
    null
)(ObjectFields);